// extracted by mini-css-extract-plugin
module.exports = {"body":"TrackingPage_body__974-D","main":"TrackingPage_main__2w7Hi"};